import { Component, HostListener, inject, Input } from '@angular/core';
import { AbstractComponent } from 'src/app/shared/components/abstract.component';
import { AppStateService } from '../../../services/app-state.service';
import { NgClass } from '@angular/common';

/* eslint-disable @angular-eslint/component-selector */
@Component({
  selector: 'button[app-burger]',
  templateUrl: './burger.component.html',
  styleUrls: ['./burger.component.scss'],
  imports: [NgClass],
})
export class BurgerComponent extends AbstractComponent {
  private readonly _appState: AppStateService = inject(AppStateService);

  @Input() public close: boolean = false;

  @HostListener('click') public onClick(): void {
    this._appState.menuOpen = !this._appState.menuOpen;
  }
}
